import { type RouteObject } from 'react-router'

import { WIKI_URL } from 'features/wiki/paths'
import { lazyDefault } from 'routes/lazy-route'

// A factory, not a hoisted const — react-router mutates a `lazy` object while
// resolving it, so two routes sharing one object silently break the second.
const wikiPage = (): ReturnType<typeof lazyDefault> =>
  lazyDefault(() => import('features/wiki/Container'))

export const wikiRoutes: RouteObject[] = [
  {
    path: WIKI_URL,
    lazy: wikiPage(),
    handle: { featureKey: WIKI_URL },
  },
  {
    path: `${WIKI_URL}/:slug`,
    lazy: wikiPage(),
    handle: { featureKey: WIKI_URL },
  },
  {
    path: `${WIKI_URL}/*`,
    lazy: wikiPage(),
    handle: { featureKey: WIKI_URL },
  },
]
